import { render, staticRenderFns } from "./SegmentModal.vue?vue&type=template&id=0ecf2d32&scoped=true&"
import script from "./SegmentModal.vue?vue&type=script&lang=js&"
export * from "./SegmentModal.vue?vue&type=script&lang=js&"
import style0 from "./SegmentModal.vue?vue&type=style&index=0&id=0ecf2d32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecf2d32",
  null
  
)

export default component.exports